import dayjs from "dayjs";

export const recvColumns=[
    {
        field: "lineNo",
        headerName: "Line No",
        align: "right",
      },
      {
        field: "skuCode",
        headerName: "SKU Code",
        align: "left",
        left:180,
        width:200
      },
      {
        field: "packType",
        headerName: "Pack Type",
        width: 120,
        align: "left",
      },
      {
        field: "baseUOM",
        headerName: "Base UOM",
        width: 120,
        align: "left",
      },
      {
        field: "cartonID",
        headerName: "Carton ID",
        width: 120,
        align: "left",
      },
      {
        field: "vDONo",
        headerName: "Do No",
        align: "left",
      },
      {
        field: "vInvNo",
        headerName: "Inv No",
        align: "left",
      },
      {
        field: "mln",
        headerName: "MLN",
        width: 120,
        align: "left",
      },
      {
        field: "expiryDate",
        headerName: "Expiry Date",
        width: 120,
        align: "left",
        valuesGetter: (col) => {
          return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
        },
      },
      {
        field: "qtyReceived",
        headerName: "Qty Received",
        width: 140,
        align: "right",
      },
      {
        field: "uom",
        headerName: "UOM",
        width: 80,
        // valueGetter: (col) => {
        //   return col?.value?.label ?? "";
        // },
        valuesGetter:(col)=>{
          return col.label

        },
        align: "left",
      },
      {
        field: "quantity",
        headerName: "Quantity",
        width: 100,
        align: "right",
      },
      {
        field: "manufacturingDate",
        headerName: "MFG Date",
        width: 120,
        align: "left",
        valuesGetter: (col) => {
          return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
        },
      },
  
      {
        field: "recvLocation",
        headerName: "Recv Location",
        width: 150,
        align: "left",
      },
      {
        field: "serialNumbers",
        headerName: "Serial Numbers Count",
        width: 120,
        align: "right",
        valuesGetter: (col) => {
          return Boolean(col) ? col.length : 0;
        },
      },
]